import { detectPlatform } from '@/lib/video-links/parseVideoLink';
import { findDuplicateSubmission } from '@/lib/video-links/findDuplicateSubmission';

/** Facebook is admitted only by ranking campaigns; publishing support is separate. */
function facebookMediaId(value: string): string | null {
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || url.username || url.password
      || !/(^|\.)facebook\.com$/i.test(url.hostname)) return null;
    const id = url.searchParams.get('v') || url.searchParams.get('story_fbid') || url.pathname.match(/\/(?:reel|videos|posts)\/(\d+)(?:\/|$)/)?.[1];
    return id && /^\d{1,30}$/.test(id) ? id : null;
  } catch { return null; }
}

export function detectCampaignSubmissionPlatform(url: string, ranking: boolean) {
  return detectPlatform(url) || (ranking && facebookMediaId(url) ? 'facebook' : null);
}

export function findCampaignSubmissionDuplicate<T extends { platform: string; url: string; disqualified?: boolean }>(url: string, submissions: T[], ranking: boolean): T | null {
  const existing = findDuplicateSubmission({ url, submissions });
  if (existing || !ranking) return existing;
  const id = facebookMediaId(url);
  return id ? submissions.find(item => !item.disqualified && item.platform === 'facebook' && facebookMediaId(item.url) === id) ?? null : null;
}
